import Preloader from '../components/global/Preloader'

/**
 * Set up global components, so we don't have to import them in every file
 */
export default {
  install (Vue) {
    Vue.component('Preloader', Preloader)
  }
}
